import { useState, useEffect } from "react";

function useMediaQuery() {
  const [size, setSize] = useState();

  useEffect(() => {
    const handleWindowResize = () => setSize(window.innerWidth);

    window.addEventListener("resize", handleWindowResize);

    handleWindowResize();
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const up = (bq) => size >= bq;
  const down = (bq) => size <= bq;

  return { up, down };
}

export default useMediaQuery;
